import { auth } from './firebase';

// Centralised auth for API calls. Rather than thread an Authorization header
// through every call site, we wrap window.fetch once and attach the current
// Firebase ID token to same-origin "/api/..." requests. Calls the Firebase SDK
// itself makes (to googleapis.com etc.) are absolute URLs and are left alone.
let installed = false;

export function installApiAuthInterceptor() {
  if (installed || typeof window === 'undefined') return;
  installed = true;

  const originalFetch = window.fetch.bind(window);
  const origin = window.location.origin;

  window.fetch = async (input: RequestInfo | URL, init?: RequestInit) => {
    const url =
      typeof input === 'string' ? input :
      input instanceof URL ? input.toString() :
      input instanceof Request ? input.url : '';

    const isApi = url.startsWith('/api') || url.startsWith(`${origin}/api`);
    if (!isApi || !auth.currentUser) {
      return originalFetch(input as any, init);
    }

    try {
      const token = await auth.currentUser.getIdToken();
      const headers = new Headers(
        init?.headers || (input instanceof Request ? input.headers : undefined)
      );
      headers.set('Authorization', `Bearer ${token}`);
      return originalFetch(input as any, { ...init, headers });
    } catch {
      // If we can't get a token, send the request unauthenticated.
      return originalFetch(input as any, init);
    }
  };
}
